"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonVerificationCodeInput = void 0;
const React = require("react");
const react_1 = require("react");
const Input_1 = require("../Input");
const constants_1 = require("../../../utils/constants");
const BronsonVerificationCodeInput = (props) => {
    const errorCodeInput = 'Por favor ingresa un valor numérico válido';
    const inputList = [];
    const { setCode, isDisabledInputCode, currentValue, numberOfDigits } = props;
    const [showError, setShowError] = (0, react_1.useState)(false);
    const mapValue = (indx, value) => {
        if (value.length === constants_1.one) {
            let newVal;
            const prev = currentValue.charAt(indx);
            if (prev) {
                newVal = currentValue.replace(prev, value);
                setCode(newVal);
            }
            else {
                newVal = `${currentValue}${value}`;
                setCode(newVal);
            }
            if (!Number(newVal)) {
                setShowError(true);
            }
            else {
                setShowError(false);
            }
            const nextVal = document.getElementById(`validation-input-${indx + constants_1.one}`);
            if (nextVal) {
                nextVal.focus();
            }
        }
    };
    for (let i = 0; i < numberOfDigits; i++) {
        inputList.push(React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'o-layout__item u-1/12 u-1/12@s u-pl-none', style: { width: '40px' } },
                React.createElement(Input_1.BronsonFormInput, { key: i, elementId: `validation-input-${i}`, maxLength: constants_1.one, defaultValue: '', onChange: (event) => mapValue(i, event.value), placeholder: '', isDisabled: isDisabledInputCode, type: 'text' })),
            i <= constants_1.two ? (React.createElement("div", { className: 'o-layout__item u-1/12 u-1/12@s u-pl-xxsmall u-ml-none u-mt-xsmall u-mr-xxsmall', style: {
                    maxWidth: '5%',
                    marginRight: '-3%',
                } },
                React.createElement("label", null, '-'))) : null));
    }
    return (React.createElement(React.Fragment, null,
        inputList,
        showError ? (React.createElement("div", { id: 'verification-code-error-msg', className: 'o-layout__item u-1/1 u-1/1@' },
            React.createElement("p", { className: 'u-text-alert' }, errorCodeInput))) : null));
};
exports.BronsonVerificationCodeInput = BronsonVerificationCodeInput;
